import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import _ from "lodash";

import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";

import { setPage, getAll } from "../../common/article/actions";
import { hashFromObj } from "../../common/lib/utils/hash";

import Pagination from "../components/Pagination/Pagination";

import moment from "moment";
moment.locale("pl");

class NewArticles extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { setPage } = this.props;

    setPage(1);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  redirectToSingle(uid) {
    this.redirect("/blog/" + uid);
  }

  render() {
    const { map, results, meta, setPage, apiHost, getAll } = this.props;
    const result = results && results.get(hashFromObj(meta && meta.toJS()));

    let limit = 0;
    const posts =
      result &&
      result.articles &&
      result.articles.map(r => {
        if (limit === 3) {
          return;
        }
        limit += 1;
        const date = moment(map.getIn([r, "addedAt"]));
        return (
          <Col
            className="text-xs-center blog-item"
            xs="12"
            sm="6"
            md="4"
            key={map.getIn([r, "uid"])}
          >
            <div className="item-wrapper">
              <Link to={`/blog/${map.getIn([r, "slug"])}`}>
                <Row>
                  <Col xs="12">
                    <img
                      className="blog-image"
                      src={`${apiHost}/v1/article/image/${map.getIn([
                        r,
                        "imageFileUid"
                      ])}`}
                      alt={map.getIn([r, "imageAlt"])}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="text-xs-center" xs="12">
                    <div className="date">
                      <div className="number">{date.date()}</div>
                      <div className="month">{date.format("MMM")}</div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <h2 className="blog-title">{map.getIn([r, "title"])}</h2>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <div className="blog-author">
                      {map.getIn([r, "author"])}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <div className="blog-short">
                      {_.truncate(map.getIn([r, "shortDesc"]), { length: 90 })}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <span className="blog-link">
                      PRZEJDŹ DO ARTYKUŁU<i className="fa fa-long-arrow-right" />
                    </span>
                  </Col>
                </Row>
              </Link>
            </div>
          </Col>
        );
      });

    return (
      <Row>
        {posts ? posts.length === 0 ? (
          <div className="loading-spinner">Brak artykułów</div>
        ) : (
          posts
        ) : (
          <Col xs="12">
            <div className="loading-spinner">
              <i className="loading-spinner fa fa-2x fa-circle-o-notch fa-spin" />
            </div>
          </Col>
        )}
      </Row>
    );
  }
}

NewArticles.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    apiHost: state.config.apiHost,
    map: state.article.map,
    results: state.article.results,
    meta: state.article.meta
  }),
  { setPage, getAll }
)(NewArticles);



/** WEBPACK FOOTER **
 ** ./src/browser/home/NewArticles.js
 **/